export const serviceCardLoadingTypes = {
  NONE: 0, // no service cards loaded
  DEFAULT: 1, // default (empty) service cards loaded
  TRUSTED: 2 // user service cards loaded
};
